import React, { useEffect, useState } from 'react';
import { fetchProfile, changePassword } from '../../services/apiService';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Profile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const token = localStorage.getItem('accessToken');

  useEffect(() => {
    const getProfile = async () => {
      try {
        const response = await fetchProfile(token);
        setProfile(response.data.user);
      } catch (err) {
        setError('Failed to fetch profile');
      } finally {
        setLoading(false);
      }
    };
    getProfile();
  }, [token]);

  const handlePasswordChange = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error("New passwords do not match");
      return;
    }

    setSubmitting(true);
    try {
      await changePassword(token, {
        currentPassword, // backend key
        newPassword      // backend key
      });
      toast.success("Password changed successfully!");
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      // show backend error message if available
      const msg = err.response?.data?.message || "Failed to change password";
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Profile</h2>

      {/* Profile Details */}
      <div className="card p-4 mb-4">
        <h4>Profile Details</h4>
        <div className="row">
          <div className="col-md-6 mb-2"><strong>Username:</strong> {profile.username}</div>
          <div className="col-md-6 mb-2"><strong>Email:</strong> {profile.email}</div>
          <div className="col-md-6 mb-2"><strong>Role:</strong> {profile.role}</div>
          <div className="col-md-6 mb-2"><strong>Status:</strong> {profile.isActive ? 'Active' : 'Inactive'}</div>
          <div className="col-md-6 mb-2"><strong>Total Deposited:</strong> ${profile.totalDeposited}</div>
          <div className="col-md-6 mb-2"><strong>Total Sessions:</strong> {profile.totalSessions}</div>
          <div className="col-md-6 mb-2"><strong>Last Login:</strong> {new Date(profile.lastLogin).toLocaleString()}</div>
          <div className="col-md-6 mb-2"><strong>Account Created:</strong> {new Date(profile.createdAt).toLocaleDateString()}</div>
        </div>
      </div>

      {/* Change Password */}
      <div className="card p-4">
        <h4>Change Password</h4>
        <form onSubmit={handlePasswordChange}>
          <div className="mb-3">
            <label className="form-label">Current Password</label>
            <input
              type="password"
              className="form-control"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">New Password</label>
            <input
              type="password"
              className="form-control"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Confirm New Password</label>
            <input
              type="password"
              className="form-control"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={submitting}>
            {submitting ? "Changing..." : "Change Password"}
          </button>
        </form>
      </div>

      {/* Toast Container */}
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
      />
    </div>
  );
};

export default Profile;
